import {
    SET_DASHBOARD_FILTERS,
    GET_OVERVIEW_REQUEST,
    GET_OVERVIEW_SUCCESS,
    GET_OVERVIEW_FAILURE,
    GET_OPERATIONS_REQUEST,
    GET_OPERATIONS_SUCCESS,
    GET_OPERATIONS_FAILURE,
    SET_OPERATIONS,
    GET_INVENTORY_REQUEST,
    GET_INVENTORY_SUCCESS,
    GET_INVENTORY_FAILURE,
    GET_TYPE_IDS_SUCCESS,
    GET_INVENTORY_ITEMS_REQUEST,
    GET_INVENTORY_ITEMS_SUCCESS,
    GET_INVENTORY_ITEMS_FAILURE,
    GET_TASK_STATUSES_REQUEST,
    GET_TASK_STATUSES_SUCCESS,
    GET_TASK_STATUSES_FAILURE
} from '../actions/dashboard';
import { defaultPeriod } from '../helpers/dashboard';

const defaultTabFilters = {
    period: defaultPeriod,
    flow: 'installations',
    companyId: ''
};

export const DASHBOARD_FILTER_TABS = ['summary', 'operations', 'inventory'];

const initialState = {
    filters: DASHBOARD_FILTER_TABS.reduce((acc, tab) => {
        acc[tab] = { ...defaultTabFilters };
        return acc;
    }, {}),
    summary: null,
    kanban: null,
    series: null,
    companies: [],
    reasons: null,
    overviewFetching: false,
    operations: [],
    operationsTotal: 0,
    operationsFetching: false,
    inventory: null,
    inventoryFetching: false,
    typeIds: {},
    inventoryByType: null,
    inventoryItemsFetching: false,
    taskStatuses: [],
    taskStatusesType: 'installations',
    taskStatusesFetching: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_DASHBOARD_FILTERS: {
            const { tab, filters } = action.payload;
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [tab]: {
                        ...state.filters[tab],
                        ...filters
                    }
                }
            };
        }
        case GET_OVERVIEW_REQUEST: {
            return {
                ...state,
                overviewFetching: true
            };
        }
        case GET_OVERVIEW_SUCCESS: {
            const { summary, kanban, series, companies, reasons } = action.payload;
            return {
                ...state,
                overviewFetching: false,
                summary,
                kanban,
                series,
                companies,
                reasons
            };
        }
        case GET_OVERVIEW_FAILURE: {
            return {
                ...state,
                overviewFetching: false
            };
        }
        case GET_OPERATIONS_REQUEST: {
            return {
                ...state,
                operationsFetching: true
            };
        }
        case GET_OPERATIONS_SUCCESS: {
            return {
                ...state,
                operationsFetching: false,
                operations: [...state.operations, ...action.payload.operations],
                operationsTotal: action.payload.total
            };
        }
        case GET_OPERATIONS_FAILURE: {
            return {
                ...state,
                operationsFetching: false
            };
        }
        case SET_OPERATIONS: {
            return {
                ...state,
                operations: action.payload.operations,
                operationsTotal: action.payload.total
            };
        }
        case GET_INVENTORY_REQUEST: {
            return {
                ...state,
                inventoryFetching: true
            };
        }
        case GET_INVENTORY_SUCCESS: {
            return {
                ...state,
                inventoryFetching: false,
                inventory: action.payload.inventory
            };
        }
        case GET_INVENTORY_FAILURE: {
            return {
                ...state,
                inventoryFetching: false
            };
        }
        case GET_TYPE_IDS_SUCCESS: {
            return {
                ...state,
                typeIds: action.payload.typeIds
            };
        }
        case GET_INVENTORY_ITEMS_REQUEST: {
            return {
                ...state,
                inventoryItemsFetching: true
            };
        }
        case GET_INVENTORY_ITEMS_SUCCESS: {
            return {
                ...state,
                inventoryItemsFetching: false,
                inventoryByType: action.payload.data
            };
        }
        case GET_INVENTORY_ITEMS_FAILURE: {
            return {
                ...state,
                inventoryItemsFetching: false,
                inventoryByType: null
            };
        }
        case GET_TASK_STATUSES_REQUEST: {
            return {
                ...state,
                taskStatusesFetching: true
            };
        }
        case GET_TASK_STATUSES_SUCCESS: {
            return {
                ...state,
                taskStatusesFetching: false,
                taskStatuses: action.payload.statuses,
                taskStatusesType: action.payload.type
            };
        }
        case GET_TASK_STATUSES_FAILURE: {
            return {
                ...state,
                taskStatusesFetching: false
            };
        }
        default:
            return state;
    }
};
